(function () {
  var ROOT_SELECTOR = "[data-wl-next-drop]";
  var CANONICAL_PATH = "/next-drop";
  var SHOPIFY_PAGE_PATHS = ["/pages/next-drop"];

  function initialize(root) {
    if (!root || root.getAttribute("data-next-drop-initialized") === "true") return;
    root.setAttribute("data-next-drop-initialized", "true");
    document.body.classList.add("wl-next-drop-page-active");
    normalizeVisiblePath();

    createTimer(root).start();
  }

  function createTimer(root) {
    var targetValue = root.getAttribute("data-launch-at");
    var targetTime = Date.parse(targetValue || "");
    var form = root.querySelector(".wl-next-drop__form");
    var successMessage = root.querySelector("[data-next-drop-success]");
    var shopLink = root.querySelector("[data-next-drop-shop-link]");
    var dayNode = root.querySelector("[data-next-drop-days]");
    var dayLabelNode = root.querySelector("[data-next-drop-days-label]");
    var hourNode = root.querySelector("[data-next-drop-hours]");
    var minuteNode = root.querySelector("[data-next-drop-minutes]");
    var secondNode = root.querySelector("[data-next-drop-seconds]");
    var intervalId;

    function render(days, hours, minutes, seconds) {
      setText(dayNode, pad(days));
      setText(hourNode, pad(hours));
      setText(minuteNode, pad(minutes));
      setText(secondNode, pad(seconds));
      setText(dayLabelNode, days === 1 ? "DAY" : "DAYS");
    }

    function setLiveState(isLive) {
      root.setAttribute("data-is-live", isLive ? "true" : "false");
      if (form && !successMessage) form.hidden = isLive;
      if (shopLink) shopLink.hidden = !isLive || Boolean(successMessage);
    }

    function tick() {
      if (!isFinite(targetTime)) {
        setLiveState(false);
        render(0, 0, 0, 0);
        return;
      }

      var remaining = Math.max(0, targetTime - Date.now());
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      var isLive = remaining <= 0;

      render(days, hours, minutes, seconds);
      setLiveState(isLive);

      if (isLive && intervalId) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
    }

    function start() {
      tick();
      if (isFinite(targetTime) && targetTime > Date.now()) {
        intervalId = window.setInterval(tick, 1000);
      }
    }

    return {
      start: start
    };
  }

  function setText(node, value) {
    if (node) node.textContent = value;
  }

  function pad(value) {
    var rounded = Math.max(0, Math.floor(value));
    return rounded < 10 ? "0" + rounded : String(rounded);
  }

  function normalizeVisiblePath() {
    if (!window.history || !window.history.replaceState) return;
    if (SHOPIFY_PAGE_PATHS.indexOf(window.location.pathname) === -1) return;
    window.history.replaceState({}, "", CANONICAL_PATH + window.location.search + window.location.hash);
  }

  function initializeAll(scope) {
    var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i += 1) {
      initialize(roots[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.matches && event.target.matches(ROOT_SELECTOR)) {
      initialize(event.target);
      return;
    }
    initializeAll(event.target);
  });
})();
